import React, { useContext } from 'react';
import { Box, Container } from '@mui/material';

import { RecordContext } from '../record-context';
import { useCustomParam } from '../../hooks/use-custom-param';
import { EditableLabel } from '../editable-label';
import { Label } from '../label';
import { SiteButton } from '../buttons/site-button';
import { updateAction } from '../action/updateAction';
import { HeroImageEditor } from '../hero-image-editor';
import arrow from '../../images/icons/arrow.svg';
import stepsIcon from '../../images/icons/steps.svg';
import userIcon from '../../images/icons/user.svg';

import { useStyles } from './styles';

export const Hero = ({ links }) => {
  const { record, recordDispatch } = useContext(RecordContext);
  const { title, author, arr, customHeroImg, heroImg } = record;
  const isEdit = false;
  const classes = useStyles();

  const handleSave = (text) => {
    recordDispatch(updateAction({...record, title: text, needSave: true }));
  }

  const heroBg = customHeroImg ? customHeroImg : heroImg

  return (
    <Box className={classes.hero} style={{backgroundImage: `url(${heroBg})`}} mb={4}>
      <Container>
        <Box pt={6} pb={5} display="flex" flexDirection="column" alignItems="center" style={{position: 'relative', zIndex: 2}}>
          <Box minHeight={48}>
            { isEdit ?
              <EditableLabel label={title}
                             handleSave={handleSave}
                             labelFontSize='32px'
                             labelFontWeight='bold'
                             inputFontSize='32px'
                             inputFontWeight='bold'
                             color='#FFFFFF'
                             lightBg={false}
              />
              : <Label label={title} labelFontSize='32px' labelFontWeight='bold' color='#FFFFFF'/>
            }
          </Box>
          <Box mt={1} mb={6} className={classes.subtitle} display="flex" flexDirection="row" alignItems="center">
            <Box mx={2} display="flex" flexDirection="row" alignItems="center">
              <img src={stepsIcon} alt="steps"/>
              &nbsp;
              {`${arr.length} steps`}
            </Box>
            <Box mx={2} display="flex" flexDirection="row" alignItems="center">
              <img src={userIcon} alt="user"/>
              &nbsp;
              {`Created by ${author}`}
            </Box>
          </Box>
          {
            links.length ?
              <Box display="flex">
                {links.map((item, index) =>
                  <Box key={index} display="flex" alignItems="center">
                    <SiteButton url={item}/>
                    {(index < links.length - 1) &&
                      <Box mr={1} ml={1}>
                        <img src={arrow} alt="arrow"/>
                      </Box>}
                  </Box>)}
              </Box>
              : ''
          }
        </Box>
      </Container>
      {
        isEdit && <HeroImageEditor />
      }
    </Box>
  )
}